"use strict";
/**
 * @def ColorSamplerSetComponent
 * @isGroup true
 * 
 * @CSSify styleName : ColorSamplerSetComponentHost/true
 * !!
 * @CSSify styleName : ColorSwatchWithSelectorComponentSwatch/false
 * !!
 * @CSSifyTheme themeName : basic-light
 * 
 */
var TypeManager = require('src/core/TypeManager');
var CreateStyle = require('src/core/GenericStyleConstructor');




var ColorSamplerSetComponentDef = function(uniqueID, options, model) {

	
	
	/**@CSSify DEBUG */		// DEBUG must be stuck (RED and bold) to trigger debug infos
		
	// Some CSS stuff (styles are directly injected in the main def below)
	/**@CSSifySlots placeholder */

	var hostStyles = [

	{
		"display": "flex",
		"flexFlow": "row",
		"flex": "1 1 0",
		"justifyContent": "space-evenly",
		"alignSelf": "flex-end",
		"selector": ":host",
		"boxSizing": "border-box",
		"background": "0",
		"border": "0",
		"boxShadow": "none",
		"margin": "0",
		"outline": "0",
		"padding": "5px",
		"verticalAlign": "baseline"
	},
	{
		"selector": "box-column:nth-child(2)",
		"marginTop": "55px"
	}

	];
	var hostStylesUseCache = {
		use : true,
		nameInCache : 'ColorSamplerSetComponentHostStyles'
	}

	
	return TypeManager.createComponentDef({
				UID : 'dummy',
				props : [
					{updateChannel : undefined}
				]
				// The definition adding the "ComponentAsCientOfaProvider" behavior is obtained via an interface
				,
				sWrapper : CreateStyle(
						hostStylesUseCache.use ? hostStylesUseCache.nameInCache : null,
						hostStyles
					)
			});
}

module.exports = ColorSamplerSetComponentDef;